
import { withRouter } from 'react-router-dom'
import MessageCenter from './MessageCenter'

export default withRouter(MessageCenter)
